import { render } from "./error-reports.vue?vue&type=template&id=94d223d8"
import script from "./error-reports.vue?vue&type=script&lang=js"
export * from "./error-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__